import { render, staticRenderFns } from "./TemplatesFilter.vue?vue&type=template&id=b1760258&"
import script from "./TemplatesFilter.vue?vue&type=script&lang=ts&"
export * from "./TemplatesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports